import React from "react";
import { View, Text, Button, TouchableOpacity, Dimensions, StyleSheet  } from "react-native";
import Modal from 'react-modal';

const {width, height} = Dimensions.get('window');
const PaymentModal = ({showModal, handleCloseModal, handleLinkClick}) => {

    const jumpToBillPage = () => {
        handleCloseModal();
        handleLinkClick();
    }


    return (
        <Modal
            style={{
                overlay: {
                    position: 'fixed',
                    top: height*0.25,
                    left: width>640? width*0.3 : width*0.1 ,
                    right: width>640? width*0.3 : width*0.1,
                    bottom: height*0.25,
                    width: width>640? width*0.4 : width*0.8,
                    height: height*0.5,
                    backgroundColor: 'rgba(255, 255, 255, 0.75)'
                },
                content: {
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    right: '10px',
                    bottom: '10px',
                    border: '1px solid #ccc',
                    background: '#fff',
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    borderRadius: '4px',
                    outline: 'none',
                    padding: '20px'
                }
            }}
            isOpen={showModal}
        >   

            <View style={styles.contentContainer}>
                <Text style={styles.title}>Reminder of payment over due</Text>

                <Text style={styles.warning}>The payment of monthly bills has not been paid in full</Text>

                <View style={[{padding: 20, margin: 5 }]}>
                    <TouchableOpacity onPress={handleLinkClick}>
                        <Text style={styles.link}>View billing</Text>
                    </TouchableOpacity>
                </View> 

                <View style={[styles.buttonContainer]}>
                    <TouchableOpacity 
                        onPress={handleCloseModal} 
                        style={styles.touchableButton}
                    >
                        <Text style={styles.buttonText}>Close</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    contentContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 100,
    },

    title: {
        width: '100%',
        marginBottom: 10,
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        color: 'black',
    },

    warning: {
        width: '100%',
        marginBottom: 10,
        textAlign: 'center',
        fontSize: 14,  
        color: 'red',
    },

    link: {
        width: '100%',
        marginBottom: 10,
        textAlign: 'center',
        fontSize: 14,  
        color: 'blue',
        textDecorationLine: 'underline'
    },

    buttonContainer: {
        alignItems: 'center',
        padding: 20,
    },

    touchableButton:{
        backgroundColor: '#2196F3',
        paddingVertical: 12,
        paddingHorizontal: 24,
        borderRadius: 5,
        alignItems: 'center',
        justifyContent: 'center',
        width: 200,
    },
    buttonText: {
        textAlign:'center', 
        fontSize: 14, 
        color: 'white'
    }
})

export default PaymentModal;